export const getTotalPages = (totalItems, count) => {
    return totalItems / count;
};
